<template>
	<div>
		<div v-if="page === 1" class="xinyong_check bg-white">
			<div class="title">{{ introoduceTitle[introoduce] }}</div>
			<itemCrad
				v-for="item in introoduceObj[introoduce]"
				:key="item.number"
				:number="item.number"
				:title="item.title"
			/>
		</div>
		<div v-if="page === 2" class="xinyong_check">
			<div class="page_2_label">为确保手环数据准确请进行<span class="primary">3次</span>血压校准</div>
			<steps :step="step" :steps="3" />
			<div class="view_base_card hardware_card">
				<van-image class="image" src="https://img01.yzcdn.cn/vant/cat.jpeg" />
				<div style="flex:1">
					<div class="name">XXXX手环</div>
					<div class="status">数据测量中(<span class="primary">60s</span>)</div>
				</div>
				<div class="right">
					<div class="wifi primary">良好</div>
					<div class="label">设备信号</div>
				</div>
			</div>
			<div class="view_base_card form_card">
				<div class="form_card_title">请输入血压仪测量结果</div>
				<van-form>
					<van-field
						v-model="value1"
						label="收缩压（高压）"
						placeholder="请输入收缩压 (mmHg)"
						:border="false"
						input-align="right"
					/>
					<van-field
						v-model="value1"
						label="舒张压（低压）"
						placeholder="请输入舒张压 (mmHg)"
						:border="false"
						input-align="right"
					/>
					<van-field
						v-model="value1"
						label="心率"
						placeholder="请输入心率 (bpm)"
						:border="false"
						input-align="right"
					/>
				</van-form>
			</div>
		</div>

		<foot-button>
			<div style="flex:1">
				<van-button v-if="page === 1" type="primary" block @click="$emit('back')"> 下一步 </van-button>
				<van-button v-if="page === 2" :disabled="disabled" type="primary" block @click="$emit('back')">
					确定
				</van-button>
				<div class="button_label">{{ buttonLabel[socketObj.status] }}</div>
			</div>
		</foot-button>

		<!-- 提醒第二/三次 -->
		<van-popup v-model="showCheckNumber" class="check_number_popup">
			<div class="check_number_popup_title">请开始第2次血压测量</div>
		</van-popup>
	</div>
</template>
<script>
import itemCrad from './components/introduce-item.vue'
import steps from './components/steps.vue'
export default {
    name: 'xinyongCheck',
    components: { itemCrad, steps },
    data () {
        return {
            page: 2,
            introoduceObj: {
                1: [
                    { number: 1, title: '测量腕围，选择合适的手环带' },
                    { number: 2, title: '佩戴手环要松紧适度，传感器处于桡动脉位置' }
                ],
                2: [
                    { number: 1, title: '气嘴向下手臂，手臂平放桌面' },
                    { number: 2, title: '袖带中心与心脏同高度，按测量开关开始测压' }
                ]
            },
            introoduceTitle: {
                1: '请佩戴手环在左手腕',
                2: '请佩戴血压计到右臂'
            },
            introoduce: 1,
            step: 1,
            buttonLabel: {
                1: '手环数据采集中，请等待数据采集成功后完成本次校准',
                2: '手环数据采集成功，请点击确认完成本次校准'
            },
            socketObj: {
                status: 1
            },
            showCheckNumber: true,
        }
    },
    computed: {
        disabled () {
            return true
        },

    }
}
</script>
<style scoped lang="less">
.xinyong_check {
	padding: 0 32px;
	min-height: calc(100vh - 216px);
	.title {
		color: #000000;
		font-size: 46px;
		padding: 60px 0;
		font-weight: bold;
		text-align: center;
	}
}
.button_label {
	font-size: 26px;
	color: #8f959e;
	text-align: center;
	margin-top: 12px;
}
.page_2_label {
	font-size: 28px;
	padding: 32px 0 42px 0;
	color: #333333;
}
.view_base_card {
	padding: 32px;
	background-color: #ffffff;
	border-radius: 16px;
	margin-top: 32px;
}
.hardware_card {
	display: flex;
	.image {
		width: 148px;
		height: 148px;
		border-radius: 24px;
		overflow: hidden;
		margin-right: 24px;
	}
	.name {
		font-size: 36px;
		line-height: 36px;
		margin: 16px 0;
		font-weight: bold;
		color: #000000;
	}
	.status {
		color: @gray-9;
		font-size: 28px;
		line-height: 36px;
	}
	.right {
		font-size: 26px;
		line-height: 26px;
		color: #bbbfc4;
		width: 106px;
		text-align: right;
		margin-left: 10px;
	}
	.wifi {
		margin-bottom: 20px;
	}
}
.form_card {
	.van-form {
		.van-field {
			padding: 29px 0;
		}
	}
	&_title {
		font-size: 32px;
		font-weight: bold;
		line-height: 36px;
		color: #000000;
	}
}
.check_number_popup {
	padding: 36px 70px;
	border-radius: 20px;
	width: 350px;
	text-align: center;
	&_title {
		font-size: 32px;
		color: #1f2329;
		margin-bottom: 32px;
	}
}
</style>
<style lang="less">
.form_card {
	.van-field__label {
		width: 315px;
		color: #333333;
		font-size: 30px;
	}
	.van-field__value {
		input {
			font-size: 28px;
		}
	}
}
</style>